import React, { useLayoutEffect, useState } from "react";
import SeemPopover from "../../../../components/SeemPopover/SeemPopover";
import SuggestionsList, { SuggestionsListHandle } from "./SuggestionsList";

type SuggestionPopoverProps = {
  items: string[];
  command: (id: string) => void;
  clientRect: (() => DOMRect | undefined) | null;
  onListRef?: (ref: SuggestionsListHandle | null) => void;
  searchValue: string;
  showFullValueTooltip?: boolean;
};

export const SuggestionPopover: React.FC<SuggestionPopoverProps> = ({
  items,
  command,
  clientRect,
  onListRef,
  searchValue,
  showFullValueTooltip = false,
}) => {
  const [virtualRef, setVirtualRef] = useState<{
    getBoundingClientRect: () => DOMRect;
  } | null>(null);

  const listRef = React.useRef<SuggestionsListHandle | null>(null);

  useLayoutEffect(() => {
    const rect = clientRect?.();
    if (!rect) {
      return;
    }
    setVirtualRef({
      getBoundingClientRect: () => rect,
    });
  }, [clientRect]);

  const handleListRef = (ref: SuggestionsListHandle | null) => {
    listRef.current = ref;
    onListRef?.(ref);
  };

  return (
    <div className="text-editor-suggestion-anchor">
      <SeemPopover
        isOpen={true}
        placement="bottom-start"
        className="text-editor-suggestion-popover"
        triggerClassName="text-editor-suggestion-trigger"
        openManagementMode={null}
        virtualReference={virtualRef}
        body={
          <SuggestionsList
            ref={handleListRef}
            items={items}
            command={(item) => {
              command(item);
            }}
            searchValue={searchValue}
            showFullValueTooltip={showFullValueTooltip}
          />
        }
      >
        <div />
      </SeemPopover>
    </div>
  );
};
